import { createContext } from 'react';

const AuthContext = createContext<{
  me: Odoo.User | null;
  isAuthenticated: boolean | null;
}>({
  me: null,
  isAuthenticated: null,
});

export default AuthContext;
